/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

/* global document, Office */
let selectedAttachments = new Map();
let currentDriveId = null; // ID de la bibliothèque de documents sélectionnée
let currentFolderId = "root"; // ID du dossier actuellement affiché
let folderPath = []; // Pour gérer le fil d'Ariane de navigation

Office.onReady((info) => {
  if (info.host === Office.HostType.Outlook) {
    /*** document.getElementById("sideload-msg").style.display = "none";
    document.getElementById("app-body").style.display = "flex";
    document.getElementById("run").onclick = run; **/

    initialize();
    setupEventListeners();
  }
});



async function initialize() {
  // Initialisation de l'interface utilisateur
  await displayAttachments();
  await loadSharePointSites();

  document.getElementById("open-in-browser-button").disabled = true;

}

function setupEventListeners() {
  document.getElementById("site-select").onchange = handleSiteChange;
  document.getElementById("library-select").onchange = handleLibraryChange;
  document.getElementById("upload-button").onclick = handleUploadClick;
   document.getElementById("open-in-browser-button").onclick = handleOpenInBrowserClick;

}

async function displayAttachments() {
  const item = Office.context.mailbox.item;
  const attachmentsContainer = document.getElementById("attachments-container");
  attachmentsContainer.innerHTML = "";

  if (!item.attachments || item.attachments.length === 0) {
    attachmentsContainer.innerHTML = "<p>Cet email n'a pas de pièce jointe.</p>";
    return;
  }

  item.attachments.forEach((attachment) => {
    // Crée un conteneur pour chaque case à cocher + label
    const div = document.createElement("div");
    div.className = "checkbox-item";

    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.id = attachment.id;
    checkbox.value = attachment.id;
    checkbox.className = "attachment-checkbox";

    const label = document.createElement("label");
    label.htmlFor = attachment.id;
    label.textContent = attachment.name;

    // ÉCOUTEUR D'ÉVÉNEMENT POUR LA SÉLECTION
    checkbox.onchange = () => {
      if (checkbox.checked) {
        // Ajoute la pièce jointe à notre Map de sélection
        selectedAttachments.set(attachment.id, attachment);
      } else {
        // Retire la pièce jointe de la sélection
        selectedAttachments.delete(attachment.id);
      }
      console.log("Pièces jointes sélectionnées:", selectedAttachments.size);
    };

    div.appendChild(checkbox);
    div.appendChild(label);
    attachmentsContainer.appendChild(div);
  });
}

function displayFolders(items) {
  const folderList = document.getElementById("folder-list");
  folderList.innerHTML = "";

  // Filtrer pour ne montrer que les dossiers
  const folders = items.filter(item => item.folder);

  if (folders.length === 0) {
    folderList.innerHTML = "<li>Aucun sous-dossier.</li>";
    return;
  }

  folders.forEach((folder) => {
    const li = document.createElement("li");
    li.className = "folder-item";
    li.textContent = `📁 ${folder.name}`;
    li.onclick = () => {
      // Ajoute le dossier au chemin de navigation et charge son contenu
      folderPath.push(folder);
      loadFolderContents(currentDriveId, folder.id);
    };
    folderList.appendChild(li);
  });
}


async function loadSharePointSites() {
  // On appelle notre propre endpoint qui, lui, appellera Graph
  const sitesData = await callApi("getSites", "POST"); 
  if (!sitesData) return;

  const siteSelect = document.getElementById("site-select");
  siteSelect.innerHTML = '<option value="">-- Choisissez un site --</option>';

  sitesData.value.forEach(site => {
      const option = document.createElement("option");
      option.value = site.id;
      option.textContent = site.description || site.displayName || site.name;
      siteSelect.appendChild(option);
  });
}

async function loadFolderContents(driveId, folderId) {
  currentFolderId = folderId;
  updateStatus("Chargement des dossiers...");
  const folderData = await callApi(`getFolders`, "POST", {driveId: driveId, folderId: folderId});
  if (!folderData || !folderData.value) {
      updateStatus("Erreur lors du chargement des dossiers.");
      document.getElementById("open-in-browser-button").disabled = true;
      return;
  }
  document.getElementById("open-in-browser-button").disabled = false;

  displayFolders(folderData.value);
  updateBreadcrumb();
  updateStatus("");
}

async function handleSiteChange() {
  const siteId = document.getElementById("site-select").value;
  console.log(`Site sélectionné : ${siteId}`);
  if (!siteId) {
    clearLibraries();
    clearFolderView();
    return;
  }
   
  updateStatus("Chargement des bibliothèques...");
  const librariesData = await callApi(`getLibraries`, "POST", { siteId: siteId });
  if (!librariesData || !librariesData.value) return;
  
  const librarySelect = document.getElementById("library-select");
  clearLibraries();

  librariesData.value.forEach((drive) => {
    const option = new Option(drive.name, drive.id);
    option.dataset.weburl = drive.webUrl;
    librarySelect.appendChild(option);
  });

  

  // Déclenche automatiquement le chargement du contenu de la première bibliothèque
  if (librarySelect.options.length > 1) {
    librarySelect.selectedIndex = 1;
    handleLibraryChange();
  }
  updateStatus("");
}

async function handleLibraryChange() {
  const librarySelect = document.getElementById("library-select");

  currentDriveId = document.getElementById("library-select").value;
  if (!currentDriveId) {
    clearFolderView();
    return;
  }
  
  const selectedOption = librarySelect.options[librarySelect.selectedIndex];
  currentDriveId = selectedOption.value;


  const libraryName = document.getElementById("library-select").options[document.getElementById("library-select").selectedIndex].text;
  const libraryWebUrl = selectedOption.dataset.weburl;
  // Initialise la navigation à la racine de la bibliothèque
  folderPath = [{ name: libraryName, id: "root", webUrl: libraryWebUrl }];
  loadFolderContents(currentDriveId, "root");
}

function updateBreadcrumb() {
  const breadcrumbDiv = document.getElementById("breadcrumb");
  breadcrumbDiv.innerHTML = "";

  folderPath.forEach((part, index) => {
    const span = document.createElement("span");
    span.textContent = part.name;

    if (index < folderPath.length - 1) {
      span.className = "breadcrumb-link";
      span.onclick = () => {
        // En cliquant, on remonte à ce niveau dans l'arborescence
        folderPath = folderPath.slice(0, index + 1);
        loadFolderContents(currentDriveId, part.id);
      };
      breadcrumbDiv.appendChild(span);
      breadcrumbDiv.append(" > ");
    } else {
      // Le dernier élément n'est pas cliquable
      breadcrumbDiv.appendChild(span);
    }
  });
}

async function callApi(endpoint, method = "GET", data = null) {
  try {
      const token = await Office.auth.getAccessToken();

      const response = await fetch(`http://bi.si-nergie.fr:7000/${endpoint}`, {
          method: method,
          headers: {
            "Content-Type": "application/json",
        },
          body: JSON.stringify({
            access_token: token,
            data: data
        })
      });

      if (!response.ok) {
          const error = await response.json();
          throw new Error(`Erreur du backend : ${error.error}`);
      }
      return response.json();

  } catch (error) {
      console.error(`Erreur lors de l'appel à /api/${endpoint}:`, error);
      updateStatus(error.message);
      return null;
  }
}

function updateStatus(message) {
  const statusDiv = document.getElementById("status");
  statusDiv.textContent = message;
}

function clearLibraries() {
  const librarySelect = document.getElementById("library-select");
  librarySelect.innerHTML = '<option value="">-- Choisissez une bibliothèque --</option>';
}

/** Vide la vue des dossiers et le fil d'Ariane */
function clearFolderView() {
  document.getElementById("folder-list").innerHTML = "";
  document.getElementById("breadcrumb").innerHTML = "";
}

async function handleUploadClick() {
  if (selectedAttachments.size === 0) {
    updateStatus("Veuillez sélectionner au moins une pièce jointe.", true);
    return;
  }
  if (!currentDriveId || !currentFolderId) {
    updateStatus("Veuillez sélectionner un dossier de destination.", true);
    return;
  }

  updateStatus(`Début du téléversement de ${selectedAttachments.size} fichier(s)...`);

  // Crée un tableau de promesses, une pour chaque téléversement de fichier.
  const uploadPromises = [];
  for (const attachment of selectedAttachments.values()) {
    uploadPromises.push(uploadSingleAttachment(attachment));
  }

  // Exécute toutes les promesses en parallèle et attend que TOUTES soient terminées.
  // Promise.allSettled est parfait car il ne s'arrête pas si une promesse échoue.
  const results = await Promise.allSettled(uploadPromises);

  // Analyse les résultats pour faire un rapport final.
  const successCount = results.filter(r => r.status === 'fulfilled').length;
  const failureCount = results.length - successCount;

  let finalMessage = `${successCount} fichier(s) téléversé(s) avec succès.`;
  if (failureCount > 0) {
    finalMessage += ` ${failureCount} échec(s).`;
  }
  updateStatus(finalMessage, failureCount > 0);
  
  // Affiche les erreurs détaillées dans la console
  results.filter(r => r.status === 'rejected').forEach(p => console.error("Détail de l'échec:", p.reason));
}

/**
 * Gère le téléversement d'UNE SEULE pièce jointe.
 * Retourne une promesse qui se résout en cas de succès ou est rejetée en cas d'échec.
 * @param {Office.Attachment} attachment - L'objet pièce jointe à téléverser.
 */
function uploadSingleAttachment(attachment) {
  // Crée une nouvelle promesse pour cet upload spécifique.
  return new Promise((resolve, reject) => {
    updateStatus(`Téléversement de ${attachment.name}...`);
    
    // Récupère le contenu de la pièce jointe au format Base64.
    Office.context.mailbox.item.getAttachmentContentAsync(attachment.id, { asyncContext: attachment }, (result) => {
      if (result.status !== Office.AsyncResultStatus.Succeeded) {
        // Rejette la promesse si la lecture du contenu échoue.
        reject(`Erreur de lecture de ${result.asyncContext.name}: ${result.error.message}`);
        return;
      }
      
      const attachmentContent = result.value.content;
      
      const uploadData = {
        fileName: result.asyncContext.name,
        base64Content: attachmentContent,
        driveId: currentDriveId,
        parentId: currentFolderId
      };

      // Appelle le backend.
      callApi("upload", "POST", uploadData)
      .then(uploadResult => {
        if (uploadResult) {
          // Résout la promesse avec succès.
          resolve(`Succès pour ${result.asyncContext.name}`);
        } else {
          // Rejette la promesse si l'appel backend échoue (callBackendApi retourne null).
          reject(`Échec du téléversement pour ${result.asyncContext.name}`);
        }
      })
      .catch(err => {
        // Rejette la promesse si une erreur inattendue se produit.
        reject(`Erreur inattendue pour ${result.asyncContext.name}: ${err.message}`);
      });
    });
  });
}
function handleOpenInBrowserClick() {
  if (folderPath.length === 0) {
    updateStatus("Aucun dossier sélectionné.", true);
    return;
  }

  // Le dossier actuel est le dernier élément du tableau folderPath
  const currentFolder = folderPath[folderPath.length - 1];
    console.log("Dossier actuel:", currentFolder);
  if (currentFolder && currentFolder.webUrl) {
    // La méthode standard et sécurisée pour ouvrir un lien depuis un complément Office
    window.open(currentFolder.webUrl);
  } else {
    updateStatus("Impossible de trouver l'URL pour ce dossier.", true);
    console.error("L'objet du dossier actuel n'a pas de propriété webUrl:", currentFolder);
  }
}